import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const popoutContainerCss: CSSObject = {
  width: "20rem",
  top: "2rem",
  right: 0,
  display: "flex",
  flexDirection: "column",
  borderRadius: "0.5rem",
  background: constants.colors.ui.white[50],
  boxShadow: "0px 2px 6px 0px rgba(29, 29, 29, 0.16)",

  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    borderRadius: "0 0 0.5rem 0.5rem",
    width: "inherit",
  },
};
